export function getCheapestShipmentCharge(orderItem) {
  const {
    shipmentCharges
  } = orderItem;
  let cheapestShipmentRate = shipmentCharges !== null && shipmentCharges !== void 0 && shipmentCharges[0] ? shipmentCharges[0] : {
    totalCharges: 0,
    serviceCode: null
  };
  (shipmentCharges || []).forEach(shipmentCharge => {
    var _shipmentCharge$total, _cheapestShipmentRate;
    const currentTotalCharges = (_shipmentCharge$total = shipmentCharge.totalCharges) !== null && _shipmentCharge$total !== void 0 ? _shipmentCharge$total : 0;
    if (currentTotalCharges < ((_cheapestShipmentRate = cheapestShipmentRate.totalCharges) !== null && _cheapestShipmentRate !== void 0 ? _cheapestShipmentRate : 0)) {
      cheapestShipmentRate = shipmentCharge;
    }
  });
  return cheapestShipmentRate.serviceCode ? cheapestShipmentRate : null;
}